<template>
    <Resize id="app" class="app-layout"  >
        <header-app></header-app>
        <div class="container">
            <transition-group name="page" @enter="enter" v-if="!$root.isMobile">
                <Main v-if="$route.name == 'Main'" :key="1"></Main>
                <Country v-if="$route.name == 'Country'" :key="2"></Country>
            </transition-group>
            <div v-else>
                <Main v-if="$route.name == 'Main'"></Main>
                <Country v-if="$route.name == 'Country'"></Country>
            </div>
        </div>
        <footer-app :class="{ 'footer-white-color' : !GET_LOAD && $route.name != 'Country' }"></footer-app>
    </Resize>
</template>

<script>
    import {TweenMax, TweenLite} from 'gsap'
    import Resize from '@/components/common/Resize';
    import headerApp from '@/components/parts/headerApp';
    import footerApp from '@/components/parts/footerApp';
    import {mapGetters} from 'vuex';

    import Country from '@/components/pages/Country'
    import Main from '@/components/pages/Main'


    export default {
        name: 'app',
        components: {
            Resize,
            'header-app':  headerApp,
            'footer-app':  footerApp,
            Country,
            Main
        },
        computed: {
            ...mapGetters(['GET_LOAD']),
            currentRoute() {
                return  this.$route.name == 'Country'
            }
        },
        methods: {
            enter() {
                if(this.currentRoute && !this.$root.isMobile) {
                    TweenMax.fromTo('.page-country-left', .3, {x:-734}, {x:0, delay: .4})
                    TweenMax.fromTo('.page-country-right', .3, {x:1400}, {x:0, delay: .6})
                }
            },
        }
    };
</script>
<style scoped>
   .page-leave-active,
   .page-enter-active  {
        transition: transform 1s ease;
    }

   .page-leave {
       transform: translateX(0);
   }

   .page-leave-to {
       transform: translateX(100%);
   }
</style>


// WEBPACK FOOTER //
// App.vue?28f6547e